import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AwpPerimetroApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }

  Get_PerimetroAWP (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/perimetroAWP/Get_perimetroAWP`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_PerimetroAWP_byfraz (frazionario: string): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/perimetroAWP/Get_perimetroAWP?frazionario=${frazionario}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
